export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8922.200bf23f.jpg";